"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.go = void 0;
/** Executes code concurrently. */
const go = (code) => {
    code().catch(() => { });
};
exports.go = go;
